import { InvestorBankAccountSortField } from '@dealstack/shared/lib/generated';
import { ColumnFiltersState } from '@tanstack/react-table';

// Only the columns the server can order by; the rest are declared unsortable in the
// column defs, so a sort can never silently fall back to a different column.
export const SORT_FIELD_BY_COLUMN_ID: Record<string, InvestorBankAccountSortField> = {
	ownerName: InvestorBankAccountSortField.OWNER_NAME,
	verificationStatus: InvestorBankAccountSortField.VERIFICATION_STATUS,
	updatedAt: InvestorBankAccountSortField.UPDATED_AT,
	createdAt: InvestorBankAccountSortField.CREATED_AT,
};

export const getTextFilter = (columnFilters: ColumnFiltersState, columnId: string) => {
	const value = columnFilters.find((filter) => filter.id === columnId)?.value;

	return typeof value === 'string' && value.trim() ? value.trim() : undefined;
};

export const toArray = (value: unknown): unknown[] => {
	if (Array.isArray(value)) {
		return value;
	}

	return typeof value === 'string' && value ? [value] : [];
};

export const getEnumArrayFilter = <T extends string>(
	columnFilters: ColumnFiltersState,
	columnId: string,
	allowed: readonly T[]
): T[] | undefined => {
	const value = columnFilters.find((filter) => filter.id === columnId)?.value;
	// A select filter hands back a single value, a multi-select an array.
	const raw = toArray(value);
	const matched = raw.filter((entry): entry is T => allowed.some((option) => option === entry));

	return matched.length ? matched : undefined;
};
